import TableShiftComponent from '../components/PanelProfessional/TableShift'

export default function TableShift(params) {
    return (
        <div>
            <TableShiftComponent/>
        </div>
    )
}